
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/simsvorun/skraning",
      function () {
        return require("private-next-pages/um/thjonusta/simsvorun/skraning.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/simsvorun/skraning"])
      });
    }
  